import { useSelector } from "react-redux";

export const useUserHooks = () => {
  //all redux
  const user_redux = useSelector((s) => s?.user);

  const userDetails = user_redux?.user || {};

  return {
    //all redux
    userDetails,
    user_redux,
  };
};
